if (!customElements.get('launch-hero')) {
  customElements.define(
    'launch-hero',
    class LaunchHero extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.launch-hero__track');
        this.slides = Array.from(this.querySelectorAll('.launch-hero__slide'));
        this.dots = Array.from(this.querySelectorAll('[data-launch-hero-dot]'));
        this.index = 0;
        if (this.slides.length < 2) return;

        this.querySelector('[data-launch-hero-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-launch-hero-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.launchHeroDot), true)));

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.play());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.play());

        let startX = null;
        this.addEventListener('touchstart', (event) => (startX = event.touches[0].clientX), { passive: true });
        this.addEventListener('touchend', (event) => {
          if (startX === null) return;
          const delta = event.changedTouches[0].clientX - startX;
          if (Math.abs(delta) > 40) this.go(this.index + (delta < 0 ? 1 : -1), true);
          startX = null;
        });

        // Theme editor: show the selected slide.
        document.addEventListener('shopify:block:select', (event) => {
          const position = this.slides.findIndex((slide) => slide.contains(event.target));
          if (position !== -1) {
            this.stop();
            this.go(position);
          }
        });

        this.play();
      }

      disconnectedCallback() {
        this.stop();
      }

      go(position, fromUser = false) {
        const count = this.slides.length;
        this.index = (position + count) % count;
        this.track.style.transform = `translateX(-${this.index * 100}%)`;

        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.setAttribute('aria-hidden', String(!active));
          slide.querySelectorAll('a, button').forEach((el) => {
            if (active) el.removeAttribute('tabindex');
            else el.setAttribute('tabindex', '-1');
          });
        });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));

        if (fromUser) {
          this.stop();
          this.play();
        }
      }

      play() {
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (window.Shopify?.designMode) return;
        this.stop();
        const delay = (Number(this.dataset.speed) || 6) * 1000;
        this.timer = setInterval(() => this.go(this.index + 1), delay);
      }

      stop() {
        clearInterval(this.timer);
      }
    }
  );
}
